import React from "react";
import RightSidebarGlobal from "../../Components/RightSidebarGlobal";
import fertilizer_1 from "../../Assets/images/fertilizer_1.jpg";
import fertilizer_2 from "../../Assets/images/fertilizer_2.jpg";


function Fertilizer(){
    return (
        <>
    <div class="wrapper">
    <div class="inner_page_Sec">
    <div class="col-sm-8 float-left left_sec searchPageTop">

    <h1>Fertilizer</h1>

    <p>Fertilizer business is one of the most important businesses of West Bengal State Cooperative Marketing Federation Ltd (BENFED).</p>
  <p>This apex Marketing Society plays a pivotal role in supply and distribution of different chemical fertilizers at the lowest 
    market price throughout the state of West Bengal through Primary Agricultural Marketing Co-operative Societies (PAMS) , 
    Primary Agricultural Credit Co-operative Societies (PACS) and other Primary Co-operative Societies situated all over West Bengal.</p>
  <p>BENFED deals with the matter of procurement, supply and distribution of different chemical, S&D, Bio, Organic fertilizers with the support 
    of the national giants like IFFCO, JCF, IPL, CIL, KRIBHCO, MATIX, MOSAIC, CHAMBAL etc. , who are legally contracted to perform business with BENFED.</p>
  <p>BENFED initiated a program called  ‘Integrated Nutrient Management (INM) Course’ with the help of Co-operation Department, 
    Govt. of West Bengal, through <a href="https://www.faidelhi.org" target="_blank">FAI-ER</a> (Fertilizer Association of India, Eastern Region)  
    to educate and certify Co-operative Society Employees’ to obtain fertilizer license which is mandatory to perform 
    fertilizer business in West Bengal. The sole motive is to increase the number of participants in Fertilizer distribution. 
    In FY 2024-25, the targeted societies for this Integrated Course are 520. Among these, 275 societies have already undergone 
    the training. The rest will be incorporated soon.</p>

    <p>Besides, engaging financially viable and eligible FPO/FPC’s ( Farmer Producers Organization/Group) as BENFED’s 
      potential partner in fertilizer distribution which may indeed broaden our customer base. The prevailing scenario of 
      Fertilizer distribution can be understood here through a few simple data:-</p>

<div className="table_data">
  <table border="0" cellpadding="0" cellspacing="0">
  <thead>
    <tr>
      <th>Sl No.</th>
      <th>Financial Year</th>
      <th>Districts Covered</th>
      <th>Total Qty. of Bulk Fertilizer (MT)</th>
      <th>Value of Fertilizer Distributed (Rs. crore)</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>1</td>
      <td>2022-23</td>
      <td>17</td>
      <td>147009</td>
      <td>307.93</td>
    </tr>
    <tr>
      <td>2</td>
      <td>2023-24</td>
      <td>17</td>
      <td>126122</td>
      <td>216.27</td>
    </tr>
    <tr>
      <td>3</td>
      <td>2024-25</td>
      <td>17</td>
      <td>115252</td>
      <td>232.56</td>
    </tr>
  </tbody>
</table>

</div>

<h2>Agri-Inputs (Plant Protection)</h2>
<p>The business of  Insecticides/Pesticides with the support of the national giants like IFFCO, JCF, IPL, CIL, 
  KRIBHCO, IFFCO-MC, MATIX, MOSAIC, CHAMBAL etc. slowly gaining pace in BENFED which in itself are very crucial 
  farming requirement. Here also, co-operative societies are partnering us. The suppliers here like in case of 
  Fertilizer are legally contracted to perform business with BENFED.</p>
<div className="table_data">
  <table border="0" cellspacing="0" cellpadding="0">
  <thead>
    <tr>
      <th>Sl No.</th>
      <th>Financial Year</th>
      <th>Suppliers Engaged</th>
      <th>Districts Covered</th>
      <th>Qty. of Insecticide / Pesticide/ Fungicide Distributed</th>
      <th>Value of Insecticide / Pesticide/ Fungicide distributed (Rs.)</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>1</td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
    </tr>
    <tr>
      <td>2</td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
    </tr>
    <tr>
      <td>3</td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
    </tr>
  </tbody>
</table>
</div>



  <p><img src={`${fertilizer_1}`} alt="" /></p>

  <h2 style={{ textAlign: 'center'}}>FARMERS</h2>
  <p><img src={`${fertilizer_2}`} alt="" /></p>

    </div>
    <div class="col-sm-4 float-left">
    <RightSidebarGlobal/>
    </div>

    </div>
    </div>

    </>
    )
}

export default Fertilizer